<template>
	<v-dialog
		v-model="modal"
		width="290px"
	>
		<template #activator="{ on, attrs }">
			<TextField
				:value="displayDate || date"
				:disabled="disabled"
				:small="small"
				append-icon="mdi-calendar"
				readonly
				:label="label"
				:rules="rules || {required: requiredDate}"
				v-bind="attrs"
				v-on="on"
			/>
		</template>
		<v-date-picker
			:value="date"
			scrollable
			:min="min"
			:max="max"
			class="custom-shared-date-picker"
			@input="value => {
				$emit('update:date', value)
				modal = false
			}"
		/>
	</v-dialog>
</template>

<script>
import TextField from './text-field.vue'
export default {
	components: { TextField },
	props: {
		label: {
			type: String
		},
		date: {
			type: String
		},
		min: {
			type: String
		},
		max: {
			type: String
		},
		displayDate: {
			type: String
		},
		disabled: {
			type: Boolean
		},
		small: {
			type: Boolean
		},
		requiredDate: {
			type: Boolean,
			default: false
		},
		rules: {
			type: [Object, Array],
			default: null
		}
	},
	data () {
		return {
			modal: false
		}
	}
}
</script>

<style scoped>
.custom-shared-date-picker ::v-deep .v-picker__title {
	background-color: var(--global-syrenis-grey) !important;
	color: var(--global-syrenis-black);
}
/* Custom styling for selected date in shared date picker */
.custom-shared-date-picker ::v-deep .v-btn--active {
	background-color: var(--global-primary) !important;
}

.custom-shared-date-picker ::v-deep .v-btn--active .v-btn__content {
	color: #fff !important;
}
.custom-shared-date-picker ::v-deep .v-date-picker-table__current {
	border-color: var(--global-primary) !important;
	color: var(--global-primary) !important;
}

</style>
